class MeowcartCustomSelect {
	constructor(element) {
		this.selectElement = element;
	}

	renderWithAutocomplete() {
		this.render({
			autocomplete(element = document.createElement('div'), value = '') {
				const span = document.createElement('span');
				span.classList.add('autocomplete');
				span.innerHTML = value;
				span.addEventListener(
					'click',
					function (e) {
						if (
							e.target.getAttribute('contenteditable') === 'true'
						) {
							e.preventDefault();
							e.stopPropagation();
							return;
						}
						span.setAttribute('contenteditable', 'true');
						const range = document.createRange();
						const selection = window.getSelection();
						range.selectNodeContents(span);
						selection.removeAllRanges();
						selection.addRange(range);
						span.focus();
						// Show all options
						for (const elementItem of element.nextSibling
							.children) {
							elementItem.style.display = '';
						}
					},
					true
				);

				span.addEventListener('blur', function (e) {
					span.removeAttribute('contenteditable');
					setTimeout(() => {
						span.innerHTML = value;
					}, 100);
				});

				span.addEventListener('input', function (e) {
					const searchValue = e.target.textContent;
					const removeDiacritics = (str) => {
						return str
							.normalize('NFD')
							.replace(/[\u0300-\u036f]/g, '');
					};
					const fuzzyMatch = (pattern, str) => {
						const patternLen = pattern.length;
						const strLen = str.length;
						if (patternLen > strLen) return false;

						let patternIdx = 0;
						let strIdx = 0;

						while (patternIdx < patternLen && strIdx < strLen) {
							if (
								pattern[patternIdx].toLowerCase().trim() ===
								str[strIdx].toLowerCase().trim()
							) {
								patternIdx++;
							}
							strIdx++;
						}

						return patternIdx === patternLen;
					};

					for (const elementItem of element.nextSibling.children) {
						if (
							fuzzyMatch(
								removeDiacritics(searchValue),
								removeDiacritics(elementItem.innerText.trim())
							)
						) {
							elementItem.style.display = '';
						} else {
							elementItem.style.display = 'none';
						}
					}
				});

				element.innerHTML = '';
				element.appendChild(span);
			},
		});
	}

	render(hooks = {}) {
		const { selectElement } = this;
		if (selectElement.dataset.selected) {
			selectElement.value = selectElement.dataset.selected;
		}
		let x, i, j, l, ll, selElmnt, a, b, c, span1;
		const svg = `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.3332 4L5.99984 11.3333L2.6665 8" stroke="#1E1E1E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
         `;
		/*look for any elements with the class "custom-select":*/
		x = [selectElement.parentElement];
		l = x.length;
		for (i = 0; i < l; i++) {
			selElmnt = x[i].getElementsByTagName('select')[0];
			ll = selElmnt.length;
			/*for each element, create a new DIV that will act as the selected item:*/
			a = document.createElement('DIV');
			a.setAttribute('class', 'select-selected');
			a.setAttribute('data-value', selElmnt.options[Math.max(selElmnt.selectedIndex, 0)].innerHTML)
			if (hooks.autocomplete) {
				hooks.autocomplete(
					a,
					selElmnt.options[Math.max(selElmnt.selectedIndex, 0)]
						.innerHTML
				);
			} else {
				a.innerHTML =
					selElmnt.options[
						Math.max(selElmnt.selectedIndex, 0)
					].innerHTML;
			}

			if (selElmnt.selectedIndex === 0) {
				a.classList.add('default-selected');
			}

			const fieldErrors =
				selectElement.parentElement.querySelector('.field-errors');
			if (fieldErrors) {
				selectElement.parentElement.insertBefore(a, fieldErrors);
			} else {
				x[i].appendChild(a);
			}
			/*for each element, create a new DIV that will contain the option list:*/
			b = document.createElement('DIV');
			b.setAttribute('class', 'select-items select-hide');
			for (j = 0; j < ll; j++) {
				/*for each option in the original select element,
				create a new DIV that will act as an option item:*/
				c = document.createElement('DIV');
				c.classList.add('select-option');
				span1 = document.createElement('span');
				span1.classList.add('done-icon');
				span1.innerHTML = svg;

				if (selElmnt.selectedIndex === j) {
					span1.classList.add('visible'); // Hiển thị biểu tượng nếu được chọn
				}

				c.appendChild(span1);

				const originalOption = selElmnt.options[j];
				for (let k = 0; k < originalOption.attributes.length; k++) {
					const attribute = originalOption.attributes[k];
					c.setAttribute(attribute.name, attribute.value);
				}
				c.innerHTML += originalOption.innerHTML;
				c.style.display = originalOption.disabled ? 'none' : '';
				c.addEventListener('click', function (e) {
					/*when an item is clicked, update the original select box,
	  and the selected item:*/
					let s, h, idx;
					s =
						this.parentNode.parentNode.getElementsByTagName(
							'select'
						)[0];

					h = this.parentNode.previousSibling;
					idx = Array.prototype.indexOf.call(
						this.parentNode.children,
						this
					);
					// Cập nhật selectedIndex và value của select gốc
					s.selectedIndex = idx;
					s.value = s.options[idx].value;
					const event = new Event('change', {
						bubbles: true,
						composed: true,
					});
					s.dispatchEvent(event);

					// Update value of selected
					if (hooks.autocomplete) {
						hooks.autocomplete(h, s.options[idx].innerHTML);
					} else {
						h.innerHTML = s.options[idx].innerHTML;
					}
					h.setAttribute('data-value', s.value);

					h.classList.remove('default-selected');

					const options =
						this.parentNode.getElementsByClassName('select-option');

					for (let k = 0; k < options.length; k++) {
						const icon = options[k].querySelector('.done-icon');
						if (k === idx) {
							icon.classList.add('visible'); // Hiển thị biểu tượng cho option được chọn
						} else {
							icon.classList.remove('visible'); // Ẩn biểu tượng cho các option khác
						}
					}

					// Xử lý phần đóng/mở dropdown
					h.click();
				});
				b.appendChild(c);
			}
			if (fieldErrors) {
				selectElement.parentElement.insertBefore(b, fieldErrors);
			} else {
				x[i].appendChild(b);
			}
			a.addEventListener('click', function (e) {
				/*when the select box is clicked, close any other select boxes,
	and open/close the current select box:*/
				e.stopPropagation();
				closeAllSelect(this);
				this.nextSibling.classList.toggle('select-hide');
				this.classList.toggle('select-arrow-active');
				this.classList.toggle('active');
			});
		}
		function closeAllSelect(elmnt) {
			/*a function that will close all select boxes in the document,
	except the current select box:*/
			let x,
				y,
				i,
				xl,
				yl,
				arrNo = [];
			x = document.getElementsByClassName('select-items');
			y = document.getElementsByClassName('select-selected');
			xl = x.length;
			yl = y.length;
			for (i = 0; i < yl; i++) {
				if (elmnt == y[i]) {
					arrNo.push(i);
				} else {
					y[i].classList.remove('select-arrow-active');
					y[i].classList.remove('active');
					x[i].classList.add('select-hide');
				}
			}
			for (i = 0; i < xl; i++) {
				if (arrNo.indexOf(i)) {
					x[i].classList.add('select-hide');
				}
			}
		}
		/*if the user clicks anywhere outside the select box,
  then close all select boxes:*/
		document.addEventListener('click', closeAllSelect);
	}

	resetCustomSelects() {
		const customSelects = document.querySelectorAll(
			'.custom-select select'
		);
		customSelects.forEach((select) => {
			select.value = '';
			const parent = select.parentElement;

			const selectedDiv = parent.querySelector('.select-selected');
			if (selectedDiv) {
				selectedDiv.innerHTML = select.options[0].innerHTML;
				selectedDiv.classList.add('default-selected');
			}

			const options = parent.querySelectorAll(
				'.select-option .done-icon'
			);
			options.forEach((icon) => {
				icon.classList.remove('visible');
			});
		});
	}
}
